// src/pages/about/Team.jsx
import React from "react";
import "./Team.css";

// Example image import
import drKaushik from "../../assets/images/doc.jpeg";

function Team() {
  // Example array of team members for a real scenario:
  const teamMembers = [
    {
      name: "Dr. Kaushik Biswas",
      qualification: "BPT",
      experience: "7 years in physiotherapy",
      specializations: ["Orthopedic Physiotherapy", "Neurological Physiotherapy"],
      background: "Dr. Kaushik Biswas has extensive experience in orthopedic rehabilitation including post-operative ACL reconstruction, knee surgeries, spondylosis, frozen shoulder mobilization, and calcaneal spur management. His expertise extends to neurological cases with focus on hemiplegic rehabilitation and pediatric cerebral palsy among others. He also provides specialized chest physiotherapy for respiratory conditions",
      interests: ["Manual and Electro Therapy", "Chronic Pain Management", "Mobilization Exercise"],
      photo: drKaushik,
      schedule: "Mon-Sat, 9 AM - 9 PM"
    },
    // ... add more team members as needed
  ];

  return (
    <div className="team-container">
      <h1 className="team-main-title">Meet Our Team</h1>

      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <div className="team-photo">
              <img src={member.photo} alt={member.name} />
            </div>
            <div className="team-info">
              <h2 className="team-name">{member.name}</h2>
              <p className="team-qualification">
                {member.qualification} — {member.experience}
              </p>
              <div className="team-specializations">
                <h3>Specializations:</h3>
                <ul>
                  {member.specializations.map((spec, i) => (
                    <li key={i}>{spec}</li>
                  ))}
                </ul>
              </div>
              <div className="team-background">
                <p>{member.background}</p>
              </div>
              <div className="team-interests">
                <h3>Areas of Interest:</h3>
                <ul>
                  {member.interests.map((interest, i) => (
                    <li key={i}>{interest}</li>
                  ))}
                </ul>
              </div>
              <div className="team-schedule">
                <strong>Schedule:</strong> {member.schedule}
              </div>
              <div className="team-actions">
                <a href="/contact" className="contact-btn">Contact</a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Team;
